/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type CartPriceTable_item$ref = any;
export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type CartItemPricing_item$ref: FragmentReference;
export type CartItemPricing_item = {|
  +lastTransaction: ?{|
    +isPrivateOffer: ?boolean,
    +mostRecentDealerOffer: ?{|
      +isSubmitted: ?boolean,
      +totalAmount: ?{|
        +convertedAmountList: ?$ReadOnlyArray<?{|
          +currency: ?Currency,
          +amount: ?number,
        |}>
      |},
    |},
  |},
  +cartPriceTableDisplayInfo: ?{|
    +pricing: ?{|
      +showSale: ?boolean,
      +showNet: ?boolean,
      +showRetail: ?boolean,
    |}
  |},
  +pricing: ?{|
    +retailPrice: ?{|
      +convertedAmountList: ?$ReadOnlyArray<?{|
        +amount: ?number,
        +currency: ?Currency,
      |}>
    |},
    +salePrice: ?{|
      +convertedAmountList: ?$ReadOnlyArray<?{|
        +amount: ?number,
        +currency: ?Currency,
      |}>
    |},
    +netPrice: ?{|
      +convertedAmountList: ?$ReadOnlyArray<?{|
        +amount: ?number,
        +currency: ?Currency,
      |}>
    |},
  |},
  +shipmentQuotes: ?$ReadOnlyArray<?{|
    +isComplimentary: ?boolean,
    +totalAmount: ?{|
      +convertedAmountList: ?$ReadOnlyArray<?{|
        +currency: ?Currency,
        +amount: ?number,
      |}>
    |},
  |}>,
  +$fragmentRefs: CartPriceTable_item$ref,
  +$refType: CartItemPricing_item$ref,
|};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "currency",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "amount",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "totalAmount",
  "storageKey": null,
  "args": null,
  "concreteType": "FinancialAmount",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "convertedAmountList",
      "storageKey": null,
      "args": null,
      "concreteType": "ConvertedAmountList",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/)
      ]
    }
  ]
},
v3 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "convertedAmountList",
    "storageKey": null,
    "args": null,
    "concreteType": "ConvertedAmountList",
    "plural": true,
    "selections": [
      (v1/*: any*/),
      (v0/*: any*/)
    ]
  }
];
return {
  "kind": "Fragment",
  "name": "CartItemPricing_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String!"
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "CartPriceTable_item",
      "args": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "lastTransaction",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "userId",
          "type": "String!"
        }
      ],
      "concreteType": "Transaction",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "isPrivateOffer",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "mostRecentDealerOffer",
          "storageKey": null,
          "args": null,
          "concreteType": "Offer",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "isSubmitted",
              "args": null,
              "storageKey": null
            },
            (v2/*: any*/)
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": "cartPriceTableDisplayInfo",
      "name": "displayInfo",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "userId",
          "type": "String"
        }
      ],
      "concreteType": "ItemDisplayInfo",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "pricing",
          "storageKey": null,
          "args": null,
          "concreteType": "PriceInfoDisplay",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "showSale",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "showNet",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "showRetail",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "pricing",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemPricing",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "retailPrice",
          "storageKey": null,
          "args": null,
          "concreteType": "FinancialAmount",
          "plural": false,
          "selections": (v3/*: any*/)
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "salePrice",
          "storageKey": null,
          "args": null,
          "concreteType": "FinancialAmount",
          "plural": false,
          "selections": (v3/*: any*/)
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "netPrice",
          "storageKey": null,
          "args": null,
          "concreteType": "FinancialAmount",
          "plural": false,
          "selections": (v3/*: any*/)
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "shipmentQuotes",
      "storageKey": null,
      "args": null,
      "concreteType": "ShipmentQuote",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "isComplimentary",
          "args": null,
          "storageKey": null
        },
        (v2/*: any*/)
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '26c42e081db3aaa9de372a63c1cb54c3';
module.exports = node;
